import { PackageAttributes } from '@/types'
import { CreatePackageMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { useNavigate } from 'react-router'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const navigate = useNavigate()

  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    mutationData
  } = useForm<CreatePackageMutation, PackageAttributes, never, never>({
    defaultValues: {
      name: '',
      description: '',
      displayOnWebsite: false,
      rateCents: 0,
      availableToEvents: false,
    },
    mutation: CreateMutation,
    resultKey: 'createPackage',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  useEffect(() => {
    if (!mutationData?.createPackage?.package?.id) return

    navigate(`/packages/${mutationData?.createPackage?.package?.id}`)
  }, [mutationData, navigate])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      <div className="grid grid-cols-2 gap-6">
        { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
        { formBuilder.buildField({ name: 'Rate', field: 'rateCents', type: 'currency' }) }
      </div>
      <div className="grid grid-cols-2 gap-6">
        { formBuilder.buildField({ name: 'Display on website', field: 'displayOnWebsite', type: 'switch' }) }
        { formBuilder.buildField({ name: 'Available to events', field: 'availableToEvents', type: 'switch' }) }
      </div>
      <div>
        { formBuilder.buildField({ name: 'Description', field: 'description', type: 'textarea' }) }
      </div>
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
